<template>
  <v-container fluid>
    <Loading :loading="!loaded" />
    <div v-if="loaded">
      <v-row align="center">
        <v-col>
          <div class="text-h6">
            {{ $t('admin.personrole.title') }}
          </div>
        </v-col>

        <v-col>
          <v-text-field
            v-model="model.query.textSearch"
            autofocus
            :label="$t('search.textSearch')"
            hide-details
            single-line
            :loading="searching"
            clearable
            solo
            @input="search"
          />
        </v-col>

        <v-col class="text-right">
          <v-btn
            color="primary"
            to="/admin/user-create"
          >
            <v-icon left> mdi-account-plus </v-icon>
            {{ $t('admin.personrole.addUser') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="6"
          align="left"
          justify="baseline"
        >
          <span class="font-italic font-weight-thin">{{ $tc('admin.personrole.resultsFound', model.data.persons.length) }}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="model.data.persons"
            :items-per-page="20"
            :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
          >
            <template #[`item.actions`]="{ item }">
              <v-btn :to="'user-edit/' + item.id" icon>
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
var searchTimeout = null;
import Loading from '@/components/Loading.vue'
import PersonRoleEdit from '@/components/PersonRoleEdit.vue'

export default {
  name: 'PersonRole',
  components: { Loading, PersonRoleEdit },
  data() {
    return {
      model: Object,
      loaded: false,
      searching: false,
      headers: [
        { text: 'Organisation', value: 'organizationTitle' },
        { text: 'Navn', value: 'fullName' },
        { text: 'Titel', value: 'title' },
        { text: 'Kontor', value: 'office' },
        { text: 'E-mail', value: 'email' },
        { text: 'Telefon', value: 'phone' },
        { text: 'Mobil', value: 'cellPhone' },
        { text: '', value: 'actions', align: 'right', sortable: false }
      ]
    }
  },
  created: async function() {
    try {
      const { data } = await this.$api.get('organizations/initpersonrolelist')

      this.model = data
    } catch (error) {
      console.error(error)
      this.$notifier.showError({})
    } finally {
      this.loaded = true
    }
  },
  methods: {
    search() {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.searching = true;
        this.$api.post('organizations/personrolelist', this.model.query)
        .then(response => {
          this.model.data = response.data.data;
          this.searching = false;
        });
      }, 450);
    }
  }
}
</script>


<style scoped>
td.nowrap {
    white-space: nowrap;
}

table thead tr th:nth-child(2) {
  position: sticky;
  left: 0;
  z-index: 3 !important;
  background: white;
}

table tbody td:nth-child(2) {
  position: sticky;
  left: 0;
  z-index: 2 !important;
  background: white;
}


</style>